import { CloseButton } from '../components/CloseButton'

/** Full-screen blue boot loader (the `validating` step): a minimal indeterminate loading bar.
 * The discreet ✕ (`onClose`) abandons the session. */
export function BootLoadingScreen({ onClose }: { onClose?: () => void }) {
  return (
    <div className="loading-stage">
      <CloseButton onClick={onClose} tone="light" />
      <div className="loading-bar" role="progressbar" aria-label="Loading" />
    </div>
  )
}
